/**
 * The three locale flags, as tiny inline SVGs. Emoji flags render as bare "RU"/"TM" letter pairs
 * on Windows, so they can't be trusted; these are simplified for legibility at ~20px — nobody can
 * read the guls on the Turkmen carpet stripe at this size, so it becomes a plain band.
 *
 * One copy for the whole admin app: the header locale strip (TopBar) and the per-locale name tabs
 * in the category modal both draw from here.
 */
import type { SupportedLocale } from '@most/i18n';

export function Flag({ locale }: { locale: SupportedLocale }) {
  const shared = 'h-3.5 w-5 shrink-0 rounded-[3px] ring-1 ring-black/10';
  switch (locale) {
    case 'ru':
      return (
        <svg viewBox="0 0 24 16" className={shared} aria-hidden="true">
          <rect width="24" height="16" fill="#fff" />
          <rect y="5.33" width="24" height="5.34" fill="#0039a6" />
          <rect y="10.67" width="24" height="5.33" fill="#d52b1e" />
        </svg>
      );
    case 'en':
      return (
        <svg viewBox="0 0 24 16" className={shared} aria-hidden="true">
          <rect width="24" height="16" fill="#012169" />
          <path d="M0 0l24 16M24 0L0 16" stroke="#fff" strokeWidth="3.2" />
          <path d="M0 0l24 16M24 0L0 16" stroke="#c8102e" strokeWidth="1.4" />
          <path d="M12 0v16M0 8h24" stroke="#fff" strokeWidth="5.2" />
          <path d="M12 0v16M0 8h24" stroke="#c8102e" strokeWidth="3" />
        </svg>
      );
    case 'tk':
      return (
        <svg viewBox="0 0 24 16" className={shared} aria-hidden="true">
          <rect width="24" height="16" fill="#00843d" />
          <rect x="2.5" width="3.5" height="16" fill="#b01e33" />
          <circle cx="11.5" cy="5" r="2.7" fill="#fff" />
          <circle cx="12.5" cy="4.4" r="2.4" fill="#00843d" />
          <circle cx="15" cy="2.4" r="0.6" fill="#fff" />
          <circle cx="16.6" cy="3.6" r="0.6" fill="#fff" />
          <circle cx="17" cy="5.6" r="0.6" fill="#fff" />
          <circle cx="15.8" cy="7.3" r="0.6" fill="#fff" />
          <circle cx="13.9" cy="7.6" r="0.6" fill="#fff" />
        </svg>
      );
  }
}
